<template>
<div id="app">
  <vue-headful :title="title" />
  <MainPage />
  <div id="loading" v-if="loading">
    <div class="spinner-wrapper">
      <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Loading"></b-spinner>
    </div>
  </div>
</div>
</template>

<script>
import MainPage from './components/MainPage.vue'
import client from 'api-client';
import { mapState } from 'vuex';

export default {
  name: 'portal',
  computed: mapState({
    loading: state => state.loading,
    hubRunning: state => state.hubRunning
  }),
  components: {
    MainPage
  },
  data() {
    return {
      title: process.env.VUE_APP_PORTAL_TITLE
    }
  },
  mounted() {
    let self = this;
    document.addEventListener('showMessage', function(event) {
      self.$bvToast.toast(event.detail.message, event.detail.options);
    });
    document.addEventListener('apiError', function(event) {
      self.$bvToast.toast(event.message.message, {
        title: event.message.title,
        variant: 'danger',
        solid: true
      });
    });
    document.addEventListener('loading', function(event) {
      self.$store.commit('setLoading', event.value);
    });

    this.$store.dispatch('samp/sampInit');

    window.sendFileBySamp = function(event, url, free) {
      event.preventDefault();
      self.$store.commit('samp/sendFileBySamp', {
        url, free,
        mtype: 'image.load.fits'
      });
      return false;
    }

    setInterval(client.keepalive, 60000);
  }
}
</script>

<style>
#loading {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 10000;
}

.spinner-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

#b-toaster-top-right {
  top: 60px;
}

.input-group-append .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

@import 'assets/css/fontello.css';

.send-by-samp-btn {
  display: none;
}

.send-by-samp-btn.active {
  display: inline;
}
</style>
